// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8b3ebf36","119":"f1e4764c","173":"7aa47f7f","236":"b1c29817","285":"107340b2","332":"d86666cc","453":"701695d5","483":"2ca586e3","610":"f72087c4","656":"612a1966","687":"b548242b","881":"bb180e42"}[chunkId] + ".chunk.js";
};